import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";

function ProgramDashboardsCard({ dashboards }) {
  const handleViewDashboard = (dashboardId) => {
    console.log("View dashboard:", dashboardId);
  };

  return (
    <Card
      sx={(theme) => ({
        height: "100%",
        borderRadius: theme.borders.borderRadius.lg,
        boxShadow: theme.boxShadows.md,
        backgroundColor: theme.functions.rgba(theme.palette.background.default, 0.8),
      })}
    >
      <MDBox p={3}>
        <MDBox display="flex" alignItems="center" mb={3}>
          <Icon sx={{ fontSize: "1.5rem", mr: 1, color: "text" }}>dashboard</Icon>
          <MDTypography variant="h5" fontWeight="bold" color="dark">
            SBI Program Dashboards
          </MDTypography>
        </MDBox>

        <Grid container spacing={2}>
          {dashboards.map((dashboard) => (
            <Grid item xs={12} sm={6} key={dashboard.id}>
              <Card
                sx={(theme) => ({
                  borderRadius: theme.borders.borderRadius.md,
                  boxShadow: theme.boxShadows.sm,
                  backgroundColor: theme.functions.rgba(theme.palette.background.default, 0.8),
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: theme.boxShadows.md,
                  },
                })}
              >
                <MDBox p={2.5}>
                  {/* Header */}
                  <MDBox mb={2}>
                    <MDTypography variant="h6" fontWeight="bold" color="dark" mb={0.5}>
                      {dashboard.name}
                    </MDTypography>
                    <MDTypography variant="body2" color="text" fontSize="0.85rem">
                      {dashboard.title}
                    </MDTypography>
                  </MDBox>

                  {/* Sparkline Placeholder */}
                  <MDBox
                    height="60px"
                    mb={2}
                    borderRadius="sm"
                    sx={{
                      background: "linear-gradient(90deg, #E3F2FD 0%, #BBDEFB 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon sx={{ fontSize: "2rem", color: "#1976D2", opacity: 0.5 }}>
                      show_chart
                    </Icon>
                  </MDBox>

                  {/* Metrics Preview */}
                  <MDBox mb={2}>
                    {dashboard.metrics.efficiency !== undefined && (
                      <MDBox display="flex" justifyContent="space-between" mb={0.5}>
                        <MDTypography variant="caption" color="text">
                          Efficiency
                        </MDTypography>
                        <MDTypography variant="caption" fontWeight="bold" color="dark">
                          {dashboard.metrics.efficiency}%
                        </MDTypography>
                      </MDBox>
                    )}
                    {dashboard.metrics.satisfaction !== undefined && (
                      <MDBox display="flex" justifyContent="space-between" mb={0.5}>
                        <MDTypography variant="caption" color="text">
                          Satisfaction
                        </MDTypography>
                        <MDTypography variant="caption" fontWeight="bold" color="dark">
                          {dashboard.metrics.satisfaction}/5.0
                        </MDTypography>
                      </MDBox>
                    )}
                    {dashboard.metrics.avgTime && (
                      <MDBox display="flex" justifyContent="space-between" mb={0.5}>
                        <MDTypography variant="caption" color="text">
                          Avg Time
                        </MDTypography>
                        <MDTypography variant="caption" fontWeight="bold" color="dark">
                          {dashboard.metrics.avgTime}
                        </MDTypography>
                      </MDBox>
                    )}
                    {dashboard.metrics.responses && (
                      <MDBox display="flex" justifyContent="space-between">
                        <MDTypography variant="caption" color="text">
                          Responses
                        </MDTypography>
                        <MDTypography variant="caption" fontWeight="bold" color="dark">
                          {dashboard.metrics.responses}
                        </MDTypography>
                      </MDBox>
                    )}
                  </MDBox>

                  {/* CTA */}
                  <MDButton
                    variant="outlined"
                    color="info"
                    size="small"
                    fullWidth
                    onClick={() => handleViewDashboard(dashboard.id)}
                  >
                    View Dashboard
                  </MDButton>
                </MDBox>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
    </Card>
  );
}

export default ProgramDashboardsCard;
